import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { confcallModes, confcallLimits } from '../utils/tariffModuleValues';

export default function TariffTelephonyOptions({ moduleKey, parameterId, value, onChange }) {
  const limits = moduleKey === 'number_extensions' ? [['max_extensions', 'Externe Rufnummernerweiterungen']] : confcallLimits;
  return <fieldset className="mt-2" aria-label={moduleKey === 'confcall' ? 'ConfCall Tarifrechte und Kapazitäten' : 'Externe Rufnummernerweiterungen'}>
    <p className="small text-muted mb-2">{moduleKey === 'confcall'
      ? 'Die drei Zugangsarten sind unabhängig kombinierbar. Kundeneinstellungen können Tarifrechte nur einschränken. PIN und Minutenabrechnung bleiben im Reiter Telefonie.'
      : 'Vollständige externe Rufnummern aus Stammnummer und Erweiterung. Dieses Recht gilt unabhängig von ConfCall.'}</p>
    {moduleKey === 'confcall' && confcallModes.map(([field, label]) => <Form.Check key={field}
      id={`module-${parameterId}-${field}`} type="checkbox" label={label}
      checked={value[field] === true} onChange={event => onChange(parameterId, field, event.target.checked)} />)}
    <Row className="mt-2">
      {limits.map(([field, label]) => <Col xs={12} md={6} key={field} className="mb-2">
        <Form.Group controlId={`module-${parameterId}-${field}`}>
          <Form.Label className="small mb-1">{label}</Form.Label>
          <Form.Control type="number" min="0" max="2147483647" step="1" required size="sm"
            value={value[field] ?? ''} onChange={event => onChange(parameterId, field, event.target.value)} />
        </Form.Group>
      </Col>)}
    </Row>
    <p className="small text-muted mb-0">Alle Mengen ausdrücklich festlegen. 0 bedeutet keine Kapazität; leer bedeutet nicht unbegrenzt.</p>
  </fieldset>;
}
